export default "__VITE_ASSET__DDceMQ_r__"